import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    Row, Col, Breadcrumb, BreadcrumbItem, Button, Label
} from 'reactstrap';
import './search-result.scss';
import Modal from '../../components/UI/Modal/Modal'
import 'react-datepicker/dist/react-datepicker.css';
import { findValue, checkSearchParameter, sortByKey, makeMultiselectObject, getSearchParameter } from './helper'
import AddCounterPartyForm from '../../Analyst/Cases/Create/AddCounterPartyForm'
// import * as constant from './constant'
import MultiSelect from '../../components/ReusableComponents/MultiSelect'
import * as caseCreateAction from '../../Analyst/Cases/Create/actions'
import * as corporateAction from '../corporate/action'
import './styles.css';
import { Preloading } from '../../components/UI/Preloader/action';
import { toast } from 'react-toastify';
import { goolgeAnalyticsEvents, setSearchTerm } from '../../components/GoogleAnalytics/index';
import * as constant from './constant'
import * as portfolioConstant from '../my-portfolio/constants'
import BuyForm from './View/BuyForm'
import KycBuyForm  from './View/KycBuyForm';
import SubscriptionReportBuy from './SubscriptionReportBuy';
import DatabaseReportForm from './DatabaseReportBuyForm/index';
import { GLOBAL_SEARCH_RESULT_BUY, REGEX1, REGEX2, REGEX3 } from './constant';
import { MODAL_TYPE_FORM } from './../../constants';
import * as createCaseActions from '../../Analyst/Cases/Create/actions' ;
import OtherReportBuyForm from './OtherReportBuyForm';


class SearchFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false,
            showModal: false,
            body: null,
            disable: false,
            filter: [],
            showFilter: false,
            searchData: [],
            applyFlag: false,
            sortFlag: false,
            selectedBuyCounterpartyId: null,
            showBuyButtons: false,
           // popoverCart: false,
            showCart: false,
            showModal: false,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            modalCloseHandler: () => { },
            selectedProductCategory:null,
            resizeZIndex: false
        };
    }

    toggle = () => {
        this.setState({
            popoverOpen: !this.state.popoverOpen,
            applyFlag: false
        }); 
    }
     
    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal
        }))
    }

    handleResizeZIndex = (resizeZIndexState) => {
        this.setState({
            resizeZIndex: resizeZIndexState
    })
    }

    setProductCategory= () => {
        if(this.props.selectedCounterParty.country === "India"){
            let cinNumber=this.props.selectedCounterParty.cinNo
            let gstNumber=this.props.selectedCounterParty.gstNo
            let panNumber=this.props.selectedCounterParty.panNo
        if((cinNumber && cinNumber!=="Not Applicable/Available" && cinNumber!=="Not Available" && cinNumber!=="Not Applicable") ||
        (gstNumber && gstNumber.charAt(5)==='C')||
        (panNumber && panNumber.charAt(3)==='C') ) {
            this.setState({selectedProductCategory:"CORPORATE"});
            return "CORPORATE";
            }
            else{
                this.setState({selectedProductCategory:"NON_CORPORATE"});
                return "NON_CORPORATE";
            }
        }else{
            this.setState({selectedProductCategory:"INTERNATIONAL"});
            return "INTERNATIONAL";
        }
    }

    componentDidMount() {
        const { match, location } = this.props
        setSearchTerm(location.pathname + location.search)
        this.props.getIndianStates()
        this.props.preloading(true)
        this.props.setsearchText(getSearchParameter(location.search)['s'])
        this.props.setsearchParam(match.params.searchParam)
        this.props.setCountryName(getSearchParameter(location.search)['country'])
        this.props.setCountryCode(getSearchParameter(location.search)['countryCode'])
        this.props.globalCounterpartySearch(checkSearchParameter(match.params.searchParam, getSearchParameter(location.search)))

    }
    componentDidUpdate(prevProps, prevState) {
        const { createdCounterparty, searchData, match, location, selectedCounterParty } = this.props
        if (this.props.location.search !== prevProps.location.search) {
            setSearchTerm(location.pathname + location.search)
        }
        if (!createdCounterparty.error && createdCounterparty !== prevProps.createdCounterparty) {
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Counterparty created successfully
                </div>
            );
            this.handleSelectedCounterparty(createdCounterparty);
            window.location.reload();
            /* this.setState({
                body: <div className="modal-content vertical-row shadow-none border-0">
                    <div className="modal-header row">
                        <h5 className="text-success">Success</h5>
                        <button type="button" onClick={this.handleCancel} className="close outline-none" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body row">
                        Counterparty created successfully
                    </div>
                    <div className="modal-footer row">
                        <Button color='primary' onClick={this.handleCreateSuccess}>OK</Button>
                    </div>
                </div>
            }) */
        }
        else if (createdCounterparty.error && createdCounterparty !== prevProps.createdCounterparty) {
            this.handleToggle();
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(createdCounterparty.error.response && createdCounterparty.error.response.data) ? createdCounterparty.error.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
        if (this.state.filter !== prevState.filter && this.state.applyFlag === true) {

            this.props.globalCounterpartySearch(checkSearchParameter(match.params.searchParam, getSearchParameter(this.props.location.search), this.state.filter))

        }
        if (getSearchParameter(this.props.location.search)['s'] !== getSearchParameter(prevProps.location.search)['s'] || match.params.searchParam !== prevProps.match.params.searchParam) {
            this.props.setsearchText(getSearchParameter(this.props.location.search)['s'])
            this.props.setsearchParam(match.params.searchParam)
            this.setState({
                showFilter: false,
                filter: [],
                searchData : [],
            }, () => {
                this.props.preloading(true);
                this.props.globalCounterpartySearch(checkSearchParameter(match.params.searchParam, getSearchParameter(this.props.location.search)))
            })

        }
        if (!this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Report Request Created Successfully
                </div>
            );

        }
        else if (this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(this.props.result.error.response && this.props.result.error.response.data) ? this.props.result.error.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            
            //this.props.history.push(`/case/view/${this.props.result.data.caseId}`)
        }

        if (searchData !== prevProps.searchData) {
            this.setState({
                showFilter: true,
                searchData: searchData.data
            }, () => { this.props.preloading(false) })
        }
        else if (searchData.data && searchData.data.length === 0 && searchData !== prevProps.searchData && this.state.showFilter === false) {
            this.setState({
                showFilter: false
            })
        }
        else if (searchData.data && searchData.data.length === 0 && searchData !== prevProps.searchData && this.state.showFilter === true) {
            this.setState({
                showFilter: true
            })
        }

        if (selectedCounterParty != prevProps.selectedCounterParty){
            this.props.preloading(false)
        }

    }
    componentWillUnmount() {
        this.props.setsearchText('')
        this.props.setsearchParam('Name')
        this.props.setCountryName('India');
        this.props.setCountryCode('IN');
    }
    handleCreateSuccess = () => {
        this.handleToggle()
        this.props.history.push(`/viewcounterparty/${this.props.createdCounterparty.id}`)
    }

    handleSelectedCounterparty = (param) => {
        //this.props.history.push(`/viewcounterparty/${param}`)//viewcounterparty/:id
        if (param.geographicType === 'DOMESTIC') {
            if (param.panNo !== null) {
                this.props.history.push(`/search-result/PAN?s=${param.panNo}&country=${param.country.name}&countryCode=${param.country.sortname}`)                
            } else if (param.gstNo !== null) {
                this.props.history.push(`/search-result/GST?s=${param.gstNo}&country=${param.country.name}&countryCode=${param.country.sortname}`)
            } else if (param.cinNumber !== null) {
                this.props.history.push(`/search-result/CIN?s=${param.cinNumber}&country=${param.country.name}&countryCode=${param.country.sortname}`)
            }
        } else {
            this.props.history.push(`/search-result/Name?s=${param.counterpartyName}&country=${param.country.name}&countryCode=${param.country.sortname}`)
        }
    }

    handleSelectedBuy = (param) => {
        this.props.preloading(true)
        this.props.viewSelectedCounterparty(param);
        this.props.getCounterpartyType();
        if(this.state.selectedBuyCounterpartyId == param){
            this.setState({
                showBuyButtons: !this.state.showBuyButtons
            });
        }else{
            this.setState({
                showBuyButtons: true, selectedBuyCounterpartyId: param
            });
        }
    }

    handleSelectedCounterpartyForInternational = (param) =>{
        if(param.counterpartyId == null){
            let address = ''
            if(param.address == ""){
                address = param.country
            }else{
                address = param.address
            }
            
           let tempRequestBody = {
                counterpartyName: param.counterpartyName,
                gstNo: null,
                panNo: null,
                pinCode: null,
                state: param.country,
                geographicType:'INTERNATIONAL',
                address: address,
                country: {
                    name:param.country,
                    sortname:''},
            }
            
        this.props.createCounterparty(tempRequestBody)
        
        }else{
            this.props.history.push(`/viewcounterparty/${param.counterpartyId}`)
        }
    }

    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal
        }))
    }
    handleCreateRequest = () => {
        goolgeAnalyticsEvents('Corporate', 'Create Case Request From Global Search Result', 'Case Request', '');
        this.handleToggle()
        this.setState({
            body: <AddCounterPartyForm closeModal={this.handleToggle} />
        })
    }

    handleApplyfilter = () => {
        goolgeAnalyticsEvents('Corporate', 'Apply Filters on  Global Search Result', 'Apply Filters', '');
        const { globalCounterpartySearch, match } = this.props
        globalCounterpartySearch(checkSearchParameter(match.params.searchParam, getSearchParameter(this.props.location.search), this.state.filter))
        this.setState({
            showFilter: true,
            applyFlag: true
        }, () => {
            this.toggle()
        })
    }

    selectedStates = (param) => {
        this.setState({
            filter: findValue(param)
        })
    }
    handleRemoveFilter = (parameter) => {
        var tempArray = [...this.state.filter]; // make a separate copy of the array
        var index = tempArray.indexOf(parameter)
        if (index !== -1) {
            tempArray.splice(index, 1);
            this.setState({
                filter: tempArray,
                applyFlag: true
            });
            this.child.handleChange(makeMultiselectObject(tempArray))
        }
        // this.child.handleChange([])

    }
    handleClearAll = () => {
        this.setState({
            filter: [],
            applyFlag: true
        })
        this.child.handleChange([])
    }
    sortData = (param) => {
        switch (param) {
            case 'existsInportfolio':
                this.setState(prevState => ({
                    sortFlag: !prevState.sortFlag,
                    searchData: sortByKey(this.state.searchData, param, this.state.sortFlag)
                }));
                break;
            case 'counterpartyName':
                this.setState(prevState => ({
                    sortFlag: !prevState.sortFlag,
                    searchData: sortByKey(this.state.searchData, param, this.state.sortFlag)
                }));
                break;
            default:
                this.setState({
                    searchdata: this.state.searchData
                })
        }

    }

    handleInvestigationReport = (result) => {
        this.handleToggle();
        let selectedProductCategory = this.setProductCategory();
        //this.handleResizeZIndex(true);
        //this.props.preloading(true);
        //this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0],this.state.selectedProductCategory,portfolioConstant.INVESTIGATED)
        //this.props.getCounterpartyType();
        this.setState({
            body: <div>
                <BuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} selectedCounterParty={this.props.selectedCounterParty} handleResizeZIndex={this.handleResizeZIndex} />
            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle,
        })
    }


    // handleVkycBuy = (counterpartyId) => {
    // }

    handleDatabaseBuy = (result) => {
        this.handleToggle();
        this.setProductCategory();
        //this.props.getCounterpartyType();
        //this.handleResizeZIndex(true);
        //this.props.preloading(true);
        //this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0],this.state.selectedProductCategory,portfolioConstant.INVESTIGATED)
        this.setState({
            body: <div>
                 <DatabaseReportForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} handleResizeZIndex={this.handleResizeZIndex} propshistory={this.props.history}/>
            </div>,
             modalType: MODAL_TYPE_FORM,
             modalTitle: 'Buy report for databse report - ' + this.props.selectedCounterParty.counterpartyName,
             modalCloseHandler: this.handleToggle,
        })

    }
    handleSubscriptionReport =(result) => {
        this.handleToggle();
        this.setProductCategory();
        //this.props.getCounterpartyType();
        //this.handleResizeZIndex(true);
        //this.props.preloading(true);
        //this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0],this.state.selectedProductCategory,portfolioConstant.SUBSCRIPTION)
        this.setState({
            body : <div>
                  <SubscriptionReportBuy toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} handleResizeZIndex={this.handleResizeZIndex} propshistory={this.props.history} />

            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for subscription report - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle, 
        })

        
    }
    handleOtherReport =(result) =>{
        this.handleToggle();
        let selectedProductCategory =  this.setProductCategory();
        //this.props.getCounterpartyType();
        //this.handleResizeZIndex(true);
        //this.props.preloading(true);
        //this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0],this.state.selectedProductCategory,portfolioConstant.OTHERS)
        this.setState({
            body : <div>
                  <OtherReportBuyForm toggle={this.handleToggle} selectedProductCategory={this.state.selectedProductCategory || selectedProductCategory} selectedvalue="" zoneSelected={[]} zoneForState={this.props.zoneFromState} buyFormType={GLOBAL_SEARCH_RESULT_BUY} handleResizeZIndex={this.handleResizeZIndex} />

            </div>,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for other report - ' + this.props.selectedCounterParty.counterpartyName,
            modalCloseHandler: this.handleToggle, 
        })

    }

    render() {
        const { searchData } = this.props
        let notAvailable
        let tableHeading
        let tableList = []
        let searchCount = 0
        let addButtonFooter
        let showFilter
        let clearAll
        let appliedFilter
        let noresFilter
        if (this.state.filter.length > 1) {
            clearAll = <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
        }
        if (searchData.data && searchData.data.length > 0 ) {
            searchCount = searchData.data.length
            if(getSearchParameter(this.props.location.search)['country'] == constant.INDIA){
                tableHeading = <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex">
                    {/* <Col sm="4" className="custom-table-header-title p-3 text-center">In my portfolio</Col> */}
                    {/*<Col xs="2" sm="2" className="custom-table-col p-sm-3 text-sm-center">&nbsp;</Col>*/}
                    <Col xs="2" sm="3" className="custom-table-header-title text-center p-3 pointer" onClick={() => this.sortData("existsInportfolio")}>In my portfolio <i className="icon-updown ml-2"></i></Col>
                    <Col xs="22" sm="21">
                        <Row noGutters>
                            <Col sm="3" className="custom-table-header-title p-3 pointer" onClick={() => this.sortData("counterpartyName")}>Company Name <i className="icon-updown ml-2"></i></Col>
                            <Col sm="3" className="custom-table-header-title p-3">Address</Col>
                            <Col sm="4" className="custom-table-header-title p-3">Identifiers</Col> 
                            <Col sm="3" className="custom-table-header-title p-3">Counterparty Status</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Last Version Date in Rubix Database</Col> 
                            <Col sm="2" className="custom-table-header-title p-3">Score Available</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Last Financial Available</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Portfolio Report Date</Col>                                                 
                        </Row>
                    </Col>
                </Row>
                tableList = this.state.searchData.map(result => {
                    return <div key={result.counterpartyId}>
                    <Row noGutters className={this.state.showBuyButtons ? "bg-light p-3 p-sm-0 mb-3 mb-sm-0" : "bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0"} key={result.counterpartyId}>
                        {/*<Col xs="2" sm="2" className="custom-table-col p-sm-3 text-sm-center">&nbsp;</Col>*/}
                        <Col xs="2" sm="3" className="custom-table-header-title text-left p-3 pointer">
                        <Button color="primary" className="mr-2" key={result.counterpartyId} onClick={(e) => this.handleSelectedBuy(result.counterpartyId)}><i className="fa fa-shopping-cart"></i></Button>
                        
                        {result.existsInportfolio ? <Link to={`/credit-worthiness/${result.counterpartyId}/${result.counterpartyType}/${result.computedReportId}`}>
                        <Button color="primary" ><i className="fa fa-eye" aria-hidden="true" ></i></Button></Link> : ""}&nbsp;
                        </Col>

                        <Col xs="22" sm="21">
                           
                            {/*<Row noGutters className="pl-3 pl-sm-0 table_row" value={result.counterpartyId} onClick={(e) => this.handleSelectedCounterparty(result.counterpartyId)}>*/}
                            <Row noGutters className="pl-3 pl-sm-0 table_row" value={result.counterpartyId}>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Company Name : </span>{result.counterpartyName}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Address : </span>{result.address}</Col>
                                <Col xs="24" sm="4" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold"> Identifiers: </span>{ "CIN: " + result.cinNo}<br/>{ "PAN: " + result.panNo}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">COUNTERPARTY STATUS : </span>{result.counterpartyStatus}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">LastDataDate : </span>{result.lastDataDate}</Col>
                                <Col xs="24" sm="2" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Score : </span>{result.score === true? 'Yes':''}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Last Financial Year : </span>{result.lastFinancialYear}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">PortfolioReportDate : </span>{result.portfolioReportDate}</Col>
                            </Row>
                        </Col>
                    </Row>

                        {this.state.selectedBuyCounterpartyId === result.counterpartyId &&  this.state.showBuyButtons ?
                         
                            <Row noGutters className="bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0">
                                <Col className="d-flex justify-content-center mb-1">
                                    <Row>
                                        <Col>
                                        <div className="btnBuy" role="group">
                                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleInvestigationReport(result)} ><i className="fa fa-shopping-cart mr-2"></i>Fresh Investigation </Button>
                                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleDatabaseBuy(result)} hidden={(!result.lastDataDate) && 'hidden'}><i className="fa fa-shopping-cart mr-2"></i> Rubix Database </Button>                                     
                                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleSubscriptionReport(result)} hidden={false}><i className="fa fa-shopping-cart mr-2"></i>Business Profile (No Score) </Button>
                                            <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleOtherReport(result)}><i className="fa fa-shopping-cart mr-2"></i>Other Reports </Button>
                                        </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            : null}
                    
                    </div>
                })
            }else{
                tableHeading = <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex">
                    {/* <Col sm="4" className="custom-table-header-title p-3 text-center">In my portfolio</Col> */}
                    {/*<Col xs="2" sm="2" className="custom-table-col p-sm-3 text-sm-center">&nbsp;</Col>*/}
                    <Col xs="2" sm="4" className="custom-table-header-title text-center p-3 pointer" onClick={() => this.sortData("existsInportfolio")}>In my portfolio <i className="icon-updown ml-2"></i></Col>
                    <Col xs="22" sm="20">
                        <Row noGutters>
                            <Col sm="5" className="custom-table-header-title p-3 pointer" onClick={() => this.sortData("counterpartyName")}>Company Name <i className="icon-updown ml-2"></i></Col>
                            <Col sm="6" className="custom-table-header-title p-3">Address</Col>
                            <Col sm="4" className="custom-table-header-title p-3">Country</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Last Version Date in Rubix Database</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Score Available</Col>
                            <Col sm="3" className="custom-table-header-title p-3">Portfolio Report Date</Col>                                                 
                        </Row>
                    </Col>
                </Row>
                tableList = this.state.searchData.map(result => {
                    return <div key={result.counterpartyId}> <Row noGutters className="bg-light p-3 p-sm-0 mb-3 mb-sm-0" key={result.counterpartyId}>
                        {/*<Col xs="2" sm="2" className="custom-table-col p-sm-3 text-sm-center">&nbsp;</Col>*/}
                        {/*<Col xs="2" sm="4" className="custom-table-col p-sm-3 mb-2 mb-sm-0 justify-content-center">{result.existsInportfolio ? <i className="icon-check"></i> : ""}</Col>*/}
                        <Col xs="2" sm="4" className="custom-table-header-title text-left p-3 pointer">
                            <Button color="primary" className="mr-2" key={result.counterpartyId} onClick={(e) => this.handleSelectedBuy(result.counterpartyId)}><i className="fa fa-shopping-cart"></i></Button>

                            {result.existsInportfolio ? <Link to={`/credit-worthiness/${result.counterpartyId}/${result.counterpartyType}/${result.computedReportId}`}>
                                <Button color="primary" ><i className="fa fa-eye" aria-hidden="true" ></i></Button></Link> : ""}&nbsp;
                        </Col>
                        <Col xs="22" sm="20">
                            <Row noGutters className="pl-3 pl-sm-0 table_row" value={result.counterpartyId} >
                                <Col xs="24" sm="5" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Company Name : </span>{result.counterpartyName}</Col>
                                <Col xs="24" sm="6" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Address : </span>{result.address}</Col>
                                <Col xs="24" sm="4" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Country : </span>{result.country}</Col> 
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">LastDataDate : </span>{result.lastDataDate}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">Score : </span>{result.score === true? 'Yes':''}</Col>
                                <Col xs="24" sm="3" className="custom-table-col p-sm-3 mb-2 mb-sm-0"><span className="d-sm-none font-family-bold">PortfolioReportDate : </span>{result.portfolioReportDate}</Col>
                            </Row>
                        </Col>
                    </Row>
                    {this.state.selectedBuyCounterpartyId === result.counterpartyId &&  this.state.showBuyButtons ?
                         
                        <Row noGutters className="bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0">
                            <Col className="d-flex justify-content-center mb-1">
                                <Row>
                                    <Col>
                                    <div className="btnBuy" role="group">
                                        <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleInvestigationReport(result)} ><i className="fa fa-shopping-cart mr-2"></i>Fresh Investigation </Button>
                                        <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleDatabaseBuy(result)} hidden={!result.lastDataDate && 'hidden'}><i className="fa fa-shopping-cart mr-2"></i> Rubix Database </Button>
                                        <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleSubscriptionReport(result)} hidden={result.country !== constant.INDIA && 'hidden'}><i className="fa fa-shopping-cart mr-2"></i>Business Profile (No Score) </Button>
                                        <Button className="mr-3 btn btn-primary btnBuy" color="primary" key={result.counterpartyId} onClick={(e) => this.handleOtherReport(result)}><i className="fa fa-shopping-cart mr-2"></i>Other Reports </Button>
                                    </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        : null}
                        </div>
                })
            }
            notAvailable = <Row className="d-flex flex-column flex-sm-row justify-content-sm-between no-gutters mb-3 position-relative align-items-sm-center">
                <p className="mb-0 search-result-count">Showing <span className="count">{searchCount}</span> results for &#34;{getSearchParameter(this.props.location.search)['s']}&#34;</p>
            </Row>
            addButtonFooter = <div className="d-flex align-items-center justify-content-center bg-light mt-4 p-3">
                <Label>Couldn&#39;t find the counterparty you were looking for?&nbsp;&nbsp;</Label>
                <Button color="primary" onClick={this.handleCreateRequest}>Create Request</Button>
            </div>


        }
        else {
            
            noresFilter = <div className="no-gutters mt-3 mb-3 d-flex flex-column flex-sm-row">
                <Label className="filter-title mr-2">Applied Filters :</Label>
                <div className="filter d-flex flex-wrap align-items-center">
                    {this.state.filter.map(p => {
                        return (
                            <span key={p} className="filter-item d-flex align-items-center mb-3 mr-3">
                                {p} <i className="icon-close pointer" onClick={() => this.handleRemoveFilter(p)}></i>
                            </span>
                        )
                    })}
                    {clearAll}
                </div>
            </div>
            if(constant.COMMON_WORDS.includes(getSearchParameter(this.props.location.search)['s'].toLowerCase())){
                notAvailable = <Col xs="24" className="text-center bg-light py-3 order-1">
                <p>Insufficient search parameter &#34;{getSearchParameter(this.props.location.search)['s']}&#34;</p>
                {this.state.showFilter ? noresFilter : ""}
                <Button color="primary" onClick={this.handleCreateRequest}>Create Request</Button>
            </Col>
            }else{
                notAvailable = <Col xs="24" className="text-center bg-light py-3 order-1">
                <p>No results found for &#34;{getSearchParameter(this.props.location.search)['s']}&#34;</p>
                {this.state.showFilter ? noresFilter : ""}
                <Button color="primary" onClick={this.handleCreateRequest}>Create Request</Button>
            </Col>
            }
            
            appliedFilter = ""
        }

        if (this.state.showFilter) {
            showFilter = <div className="filter-wrapper ml-sm-auto mb-4">
                <Button id="Popover1" className="btn-icon btn-filter" outline size="sm" color="primary" onClick={this.toggle}>
                    <i className="icon-filter"></i>
                </Button>
                <div className={this.state.popoverOpen ? "position-absolute filter-popover d-block bg-light p-3" : "position-absolute filter-popover d-none p-3"}>
                    <Row className="mb-3 align-items-center">
                        <Col xs="4" className="filter-category py-0 py-sm-20">
                            <span className="filter-popover-header-item d-flex justify-content-between align-items-center mb-3 mb-sm-0">State</span>
                        </Col>
                        <Col sm="15" className="filter-category py-sm-20 ">
                            <MultiSelect ref={instance => { this.child = instance; }} data={this.props.indianStateList.sort()} selected={this.selectedStates} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-between">
                            <Button outline color="primary" onClick={this.toggle}>Hide Filters</Button>
                            <Button color="primary" onClick={this.handleApplyfilter}>Apply</Button>
                        </Col>
                    </Row>

                </div>
            </div>
            appliedFilter =
                <div className="no-gutters mb-3 d-flex flex-column flex-sm-row">
                    <Label className="filter-title mr-2">Applied Filters :</Label>
                    <div className="filter d-flex flex-wrap align-items-center">
                        {this.state.filter.map(p => {
                            return (
                                <span key={p} className="filter-item d-flex align-items-center">
                                    {p} <i className="icon-close pointer" onClick={() => this.handleRemoveFilter(p)}></i>
                                </span>
                            )
                        })}
                        {clearAll}
                    </div>
                </div>
        }
        return (
            <Col className="search-result">
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Search Result</BreadcrumbItem>
                </Breadcrumb>
                <Modal show={this.state.showModal} className={this.state.resizeZIndex ? "z-index-zero Large-Modal" : "Large-Modal"} modalClosed={this.handleToggle} >
                    {this.state.body}
                </Modal>

                <div className="d-flex justify-content-between flex-column flex-sm-row position-relative flex-wrap">
                    {notAvailable}
                    {showFilter}
                </div>
                {noresFilter ? "" : appliedFilter}
                {tableHeading}
                {tableList}
                {addButtonFooter}

            </Col>

        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    searchData: state.corporate.globalSearchResult,
    searchText: state.corporate.searchText,
    countryName: state.corporate.countryName,
    indianStateList: state.createCase.statesList,
    createdCounterparty: state.createCase.createdCounterParty,
    selectedCounterParty: state.corporate.selectedCounterParty,
    result: state.createCase.result,
    userDetails: state.loginDetails.userDetails,
    counterpartyType: state.createCase.dropdownData
})

const mapDispatchToProps = (dispatch) => ({
    globalCounterpartySearch: (param, search, stateList) => { dispatch(corporateAction.globalCounterpartySearch(param, search, stateList)) },
    getIndianStates: () => { dispatch(caseCreateAction.getIndianStates()) },
    createCounterparty: (counterparty) => {dispatch(caseCreateAction.createCounterparty(counterparty));},
    filteredSearch: (search, stateList) => { dispatch(corporateAction.advancedGlobalCounterpartySearch(search, stateList)) },
    setsearchParam: (searchParam) => { dispatch(corporateAction.searchParameter(searchParam)) },
    setsearchText: (searchText) => { dispatch(corporateAction.searchText(searchText)) },
    setCountryName: (countryName) => { dispatch(corporateAction.countryName(countryName)) },
    setCountryCode: (countryCode) => { dispatch(corporateAction.countryCode(countryCode)) },
    preloading: (status) => { dispatch(Preloading(status)) },
    viewSelectedCounterparty: (counterpartyId) => { dispatch(corporateAction.viewSelectedCounterparty(counterpartyId)) },
    getCounterpartyType: () => { dispatch(createCaseActions.getCounterpartyType()) },
    getProducts: (corporateId, type,selectedProductCategory,reportCategory) => { dispatch(createCaseActions.getProducts(corporateId, type,selectedProductCategory,reportCategory)) },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);

